import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { fetchTagsAPI } from "../../api/apiv2";

// Async thunk to fetch available tags
export const fetchAvailableTags = createAsyncThunk(
  "availableTags/fetchAvailableTags",
  async () => {
    const data = await fetchTagsAPI();
    return data;
  }
);

const availableTagsSlice = createSlice({
  name: "availableTags",
  initialState: {
    value: [],
  },
  reducers: {
    setAvailableTags: (state, action) => {
      state.value = action.payload;
    },
    clearAvailableTags: (state) => {
      state.value = [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAvailableTags.fulfilled, (state, action) => {
      state.value = action.payload;
    });
  },
});

export const { setAvailableTags, clearAvailableTags } =
  availableTagsSlice.actions;
export default availableTagsSlice.reducer;
